import type { RegulatoryFooter } from '@ps/web-martech-cms-types';
import { Link } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import CMSHTML from '../../../CMSHTML/CMSHTML';
import CMSImage from '../../../CMSImage/CMSImage';

import styles from './RegulatoryFooterES.scss';

interface Props {
  regulatory_footer: RegulatoryFooter[];
}

const RegulatoryFooterES: React.FC<Props> = ({
  regulatory_footer: [
    {
      texts: [{ content }],
      icons: [icon]
    }
  ]
}) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const selfExclusionModalPath = '/account/responsible/take-a-break-from-us';
  const { modal } = useDispatch<Dispatch>();

  const handleNativeSelfExcludeModal = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    if (isEmbedded) {
      window.starsweb?.app?.execute('account/responsible/self-exclude');
      return;
    }

    modal.enqueue(
      isAuthenticated
        ? { path: selfExclusionModalPath }
        : { path: '/auth/login', locationState: { path: selfExclusionModalPath } }
    );
  };

  return (
    <div className={styles.container}>
      <Link
        trackText="Self-Exclusion"
        className={styles.wrapper}
        onClick={handleNativeSelfExcludeModal}
      >
        <CMSImage {...icon} />
        <CMSHTML preventClick content={content} />
      </Link>
    </div>
  );
};

export default RegulatoryFooterES;
